import React, { useCallback, useContext, useEffect, useImperativeHandle, useRef, useState } from "react"
// @ts-ignore
import Loader from "react-spinner-loader"
import { ActivityGame } from "../../../modules/games/game"
import { ActivityInfo } from "../../../modules/lesson/activity/activity.types"
import { getAuthUserInfo } from "../../../infra/security/auth-user-token"
import { GameContext, SubmitGameStarted, SubmitProviderResponse } from "./game"
import sha1 from "crypto-js/sha1"
import hex from "crypto-js/enc-hex"

type GameWindowProp = {
  activity?: ActivityInfo | null;
  startGame: boolean | null;
  game: ActivityGame | undefined;
  gameSessionId: string;
}

const GameWindow = ({ activity, game, startGame, gameSessionId }: GameWindowProp) => {

  const endGameUrl = `#ended`
  const authUserInfo = getAuthUserInfo()

  const gameContext = useContext(GameContext)!

  useEffect(() => {

    // const gameId = gameContext.isActivityMode ? activity!.pk_lesson_activity_key
    //   : sha1(authUserInfo?.student_key + (Math.random()).toString()).toString(hex)

    console.info("startGame: ", startGame)
    console.info("gameId: ", gameSessionId)
    if (startGame) {

      const script = document.createElement("script")
      script.innerHTML = `

            arcademics.display("gameContainer", "${game?.providerGameId}", {
              affiliate: "SGEduacademy",
              lang:"en",
              playerName: "${authUserInfo!.name}",
              playerNameEditable: true,
              zoneId: "zone_${authUserInfo!.userId}",
              endGameEnabled: true,
              userId: "${authUserInfo!.userId}",
              endGameURL: "${endGameUrl}",
              gameId: "${gameSessionId}",
              introDuration:0,
              // quickStart: true,
              
              gameplayData: (data) => {
                  // window.gameWindowApi.onGameEnd(data);
                  window.gameWindowApi.onGameplayData(data);
              },
              
              gameplayStartCallback: () => {
                console.info('gameplayStartCallback');
                window.gameWindowApi.onGameplayStart();
              },

              gameplayStopCallback: () => {
                window.gameWindowApi.onGameStop();
              }
              
            });
        `
      document.body.appendChild(script)
      return () => {
        document.body.removeChild(script)
      }
    }
  }, [startGame])

  if (gameContext.isActivityMode && !activity) {
    return <div>
      Error: activity cannot be empty if mode is 'activity'
    </div>
  }


  return (
    <>
      <div className="d-flex w-100 p-3 pt-0">
        <div id="gameContainer"
             style={{ width: "100%", height: "70vh" }}
        ></div>
      </div>
    </>
  )
}


type AracdemicsGameProp = {
  activity?: ActivityInfo | null;
  game: ActivityGame;
  setGameStarted: () => void;
  submitSessionResult: (data: SubmitProviderResponse) => Promise<void>;
  submitGameStarted: (data: SubmitGameStarted) => Promise<void>;
  onGameEndedCallback: () => void;
}

export const AracdemicsGame = React.memo(
  ({
     activity, game, setGameStarted, submitSessionResult, submitGameStarted,
     onGameEndedCallback
   }: AracdemicsGameProp) => {

    const [loading, setLoading] = useState<boolean>(true)
    const [startGame, setStartGame] = useState<boolean>(false)
    const gameplayDataList = useRef<any[]>([])

    const authUserInfo = getAuthUserInfo()

    const gameSessionId = sha1(authUserInfo?.student_key + (Math.random()).toString()).toString(hex);

    const gameplayStartedSaved = useRef<boolean>(false);

    const handleHashChange = useCallback(() => {

      const hash = window.location.hash

      if (hash === "#ended") {

        submitSessionResult({
          providerId: game.providerId,
          providerGameId: game.providerGameId,
          providerResponse: gameplayDataList.current,
          gameSessionId: gameSessionId
        })
          .then(onGameEndedCallback)
      }

    }, [submitSessionResult])

    useEffect(() => {

      const hash = window.location.hash
      if (hash === "#ended") {
        window.location.hash = ""
      }

      window.addEventListener("hashchange", handleHashChange)
      return () => {
        window.removeEventListener("hashchange", handleHashChange)
      }
    }, [handleHashChange])


    useEffect(() => {
      if (startGame) {
        setGameStarted()
      }
    }, [startGame])

    const apiRef = useRef({})
    useImperativeHandle(apiRef, () => ({

      onGameplayData(data: any) {
        gameplayDataList.current.push(data)
      },

      onGameStop(data: any) {
        console.info("onGameStop")
        console.info(gameplayDataList.current)
      },

      onGameplayStart() {
        if(!gameplayStartedSaved.current) {
          submitGameStarted({
            providerId: game.providerId,
            providerGameId: game.providerGameId,
            providerResponse: gameplayDataList.current,
            gameSessionId: gameSessionId
          })
            .then(response =>{
              gameplayStartedSaved.current = true;
            })
        }
      }

    }), [activity, game])

    useEffect(() => {
      // @ts-ignore
      window.gameWindowApi = apiRef.current
    }, [activity, game])

    useEffect(() => {
      const script = document.createElement("script")
      script.src = "https://static.arcademics.com/games-html5/arcademics.js"
      script.async = true

      document.body.appendChild(script)

      script.onload = () => {
        setLoading(false)
        setStartGame(true)
      }

      return () => {
        document.body.removeChild(script)
      }
    }, [])

    return (
      <div>
        <Loader show={loading} type="body" />

        <div className="m-2 p-2" style={{ fontSize: "1.5em", border: "2px red solid" }}>
          Centre Optional Add on - Free Trial for one month
        </div>

        <div className="m-2 p-2" style={{ fontSize: "1.5em", border: "2px red solid" }}>
          When the game ends, please remember to press the <b><i>END GAME</i></b> button. If not, your results won't be
          saved
        </div>

        {(startGame)
          && <GameWindow
            activity={activity} startGame={startGame} game={game}
            gameSessionId={gameSessionId}
          ></GameWindow>
        }
      </div>
    )

  }
)